// @flow

import React, { Component } from 'react';

import './ToastrContent.scss';

type Props = {
  children: any,
}

export default class ToastrContent extends Component {
  props: Props;

  render() {
    if (!this.props.children) {
      return null;
    }

    return (
      <div className="toastr-content">
        {this.props.children}
      </div>
    );
  }
}
